import axiosInstance from "../axiosInstance";

const CONTROLLER = "Auditory";

const get_auditory = async (month, year, quarter, client) => {
  const response = await axiosInstance.post(
    `${CONTROLLER}/GetAuditoryCT`,
    { month: month, year: year, quarter: quarter, client: client },
    {
      responseType: "blob",
    }
  );
  return response.data;
};

const get_generated_file_list = async (folderPath, folderName) => {
  const response = await axiosInstance.get(
    `${CONTROLLER}/GetGeneratedFileList?folderPath=${folderPath}&folderName=${folderName}`
  );
  return response.data;
};

const download_file_content = async (filePath) => {
  const response = await axiosInstance.get(
    `${CONTROLLER}/DownloadFileContent?filePath=${filePath}`,
    {
      responseType: "blob",
    }
  );
  return response.data;
};

const move_file_in_blob = async (filePath, sourceFolder, destinationFolder) => {
  const response = await axiosInstance.get(
    `${CONTROLLER}/MoveFile?filePath=${filePath}&sourceFolder=${sourceFolder}&destinationFolder=${destinationFolder}`
  );
  return response.data;
};

const get_states_auditory = async (
  month,
  year,
  quarter,
  client,
  distributorId
) => {
  const response = await axiosInstance.post(
    `${CONTROLLER}/GetAuditoryStatesCT`,
    {
      month: month,
      year: year,
      quarter: quarter,
      client: client,
      distributorId: distributorId,
    },
    {
      responseType: "blob",
    }
  );
  return response.data;
};

export {
  get_auditory,
  get_generated_file_list,
  download_file_content,
  move_file_in_blob,
  get_states_auditory,
};
